import handleError from "@/mixins/handle-error";
import handleSuccess from "@/mixins/handle-success";

export default {
  mixins: [handleError, handleSuccess],
  methods: {
    clearMessage: function() {
      // TODO エラー時のメッセージと成功時のメッセージの処理を分けてしまったので、各画面で当メソッドを呼ばないといけなくなってしまった
      // 見直しが必要
      this.$route.params.success = undefined;
      this.$route.params.error = undefined;
      this.errorObject = undefined;
      this.successObject = undefined;
    }
  }
};
